import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';

import { UserService } from '../services/user.service';
import { MenuItem, ContextService } from '../core/context.service';
declare let $: any;

@Component({
  selector: 'tv-menu',
  templateUrl: './menu.component.html',
  styleUrls: [
    './menu.component.css'
  ]
})
export class MenuComponent implements OnInit, OnDestroy {
  @Input() sideNav: MatSidenav;

  menuItems: MenuItem[];
  private contextChangedSubscription: Subscription;

  constructor(
    private userService: UserService,
     private router: Router,
    private contextService: ContextService
    ) {}

  ngOnInit() {
    this.contextChangedSubscription =
     this.contextService.contextChanged.subscribe(() => this.initialise());
    this.initialise();
    $("#search").on("keyup", function () {
      if (this.value.length > 0) {
        $("tv-menu > mat-nav-list > tv-menu-item").hide().filter(function () {
          return $(this).text().toLowerCase().replace("expand_more", "").indexOf($("#search").val().toLowerCase()) != -1;
        }).show();
      }
      else {
        $("tv-menu > mat-nav-list > tv-menu-item").show();
      }
    });
  }

  ngOnDestroy() {
    this.contextChangedSubscription.unsubscribe();
  }

  private initialise() {
    if (this.contextService.isLoggedIn === false) {
      this.menuItems = [];
      return;
    }

    this.userService.getMenu().subscribe(
      result => {
      //  result[2].children[1]=JSON.parse('{"displayName":"Cash Transaction","screenId":1503,"screenCode":"cashtransaction","relativePath":"/transaction/cash","queryString":{"isTrustTransaction":true},"children":[]}');
     // result[18].children.push(JSON.parse('{"displayName":"Report Definition","screenId":8080,"screenCode":"reportdefinition","relativePath":"/reportdefinition","queryString":{"isTrustTransaction":true},"children":[]}')); 
      this.menuItems = result;
        console.log('Final Menu', this.menuItems);
      },
      err => {
        console.log('user service error ', err);
      });
  }


  navigate(path: string): void {
    this.router.navigate([path]);
  }
  ngAfterViewChecked() {

    // $("tv-menu > mat-nav-list > tv-menu-item").click(function () {
    //   let child = $(this).children("div");


    // });
    ////placeholder float
    // $("[id^=search_sub_menu_]").on("click", function () {
    //   let id = $(this).attr('id');
    //   if (!$("#" + id).parents("mat-form-field").hasClass("mat-form-field-should-float"))
    //     $("#" + id).parents("mat-form-field").addClass("mat-form-field-should-float mat-focused");
    // });

    ///on change search
    // $("[id^=search_sub_menu_]").on("keyup", function () {
    //   let id = $(this).attr('id');
    //   if (this.value.length > 0) {
    //     $(this).parents("mat-form-field").parent("div").children("tv-menu-item").hide().filter(function () {
    //       return $(this).text().toLowerCase().indexOf($("#" + id).val().toLowerCase()) != -1;
    //     }).show();
    //   }
    //   else {
    //     $("div > tv-menu-item").show();
    //   }
    // });

    ///on focus out, unfloat the placeholder if search textbox is empty
    // $("[id^=search_sub_menu_]").on("focusout", function () {
    //   let id = $(this).attr('id');
    //   if ($("#" + id).val() == "")
    //     $("#" + id).parents("mat-form-field").removeClass("mat-form-field-should-float mat-focused");
    // });
    ///on click of any sub menu, unfloat the placeholder and clear search textbox
    // $("div > tv-menu-item").on("click", function () {
    //   //$("[id^=search_sub_menu_]").val('');

    //   $("[id^=search_sub_menu_]").parents("mat-form-field").removeClass("mat-form-field-should-float mat-focused");
    // });
  }
}
